import React, { useMemo } from "react";
import { Marker, Popup } from "react-leaflet";
import { NETSTAT_SWITCH_URL, SERVICE_HOUSE_URL } from "../Optics/OpticApiConfig";
import { icon100pab, icon30k, icon3k, icon100k, iconKp } from "./constants/MapConstants";


const SwitchMarker = ({ coordinate, switches, zoomLevel, layersVisibility }) => {
  const duplicateCoordinates = useMemo(
    () => switches.filter(c => c.hid === coordinate.hid && c.entrance === coordinate.entrance),
    [switches, coordinate.hid, coordinate.entrance]
  );

  const maxRankCoordinate = useMemo(
    () => [coordinate, ...duplicateCoordinates].reduce((acc, curr) => (curr.rank < acc.rank ? curr : acc), coordinate),
    [coordinate, duplicateCoordinates]
  );

  const filteredCoords = useMemo(
    () => [...new Map([maxRankCoordinate, ...duplicateCoordinates]
        .filter(c => c.ip)
        .map(c => [c.ip, c])
    ).values()],
    [maxRankCoordinate, duplicateCoordinates]
  );

  let markerIcon = null;
  let isVisible = false;

  if (maxRankCoordinate.rank === 4  && layersVisibility.icon100pab) {
    markerIcon = icon100pab;
    isVisible = true;
  } else if (maxRankCoordinate.rank === 3 ) {
    if (maxRankCoordinate.modelSw === "Контроль питания, ранг 3" && layersVisibility.iconKp) {
      markerIcon = iconKp;
      isVisible = true;
    } else if (layersVisibility.icon3k) {
      markerIcon = icon3k;
      isVisible = true;
    }
  } else if (maxRankCoordinate.rank === 2 && layersVisibility.icon30k) {
    markerIcon = icon30k;
    isVisible = true;
  } else if (maxRankCoordinate.rank === 1 && layersVisibility.icon100k) {
    markerIcon = icon100k;
    isVisible = true;
  }

  if (!isVisible) return null;

  return (
    <Marker position={[maxRankCoordinate.latitude, maxRankCoordinate.longitude]} icon={markerIcon}>
      <Popup className="custom-popup-auto-topo" autoPan={false}>
        <span style={{ fontWeight: "bold", color: '#fabf66ff' }}>Адрес:</span>  <a
                            href={`${SERVICE_HOUSE_URL}?Id=${maxRankCoordinate.hid}`}
                            target="_blank"
                            style={{ fontWeight: 'bold', color: '#d1d1d1' }}
                          >
                            {maxRankCoordinate.street}, дом. {maxRankCoordinate.numberHouse}
                          </a><br/>
        <span style={{ fontWeight: "bold", color: '#fabf66ff' }}>Подъезд:</span><span style={{color: '#d1d1d1'}}> {maxRankCoordinate.entrance}</span><br/>
       
       
        <hr style={{color: '#ffffffff', marginTop: '5px', marginBottom: '10px'}}/>
        {filteredCoords.length > 0 ? filteredCoords.map((coord, idx) => (
          <div key={idx} className='custom-box-telecom-auto-topo ' style={{ marginBottom: '3px' }}>
            <span style={{ fontWeight: "bold", fontSize: "12px" }}>Ранг:</span> <span style={{ fontSize: "12px" }}>{coord.rank}</span><br/>
            <span style={{ fontWeight: "bold", fontSize: "12px" }}>Модель:</span> <span style={{ fontSize: "12px" }}>{coord.modelSw}</span><br/>
            <span style={{ fontWeight: "bold", fontSize: "12px" }}>Ip:</span> 
            <span style={{ fontSize: "12px" }}>
              <a href={`${NETSTAT_SWITCH_URL}?ip=${coord.ip}`} target="_blank" rel="noreferrer" style={{ fontWeight: "bold", color:"#005fb8" }}>{coord.ip}</a>
            </span>
          </div>
        )) : <p>Нет данных для отображения</p>}
      </Popup>
    </Marker>
  );
};

export default SwitchMarker;